import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-fix',
  templateUrl: './fix.component.html',
  styleUrls: ['./fix.component.css'],
})
export class FixComponent implements OnInit {
  @Input() errorMessage = '';
  constructor() {}

  ngOnInit(): void {}
}
